<template>
  <div class="film-section">
    <p class="p1">— {{ $t("home.v2.film.p1") }} —</p>
    <p class="p2">{{ $t("home.v2.film.title1") }}</p>
    <p class="p2">{{ $t("home.v2.film.title2") }}</p>
    <p class="p3">
      {{ $t("home.v2.film.desc") }}
    </p>
    <p class="p4" @click="openVideoDialog">
      <img src="@/assets/img/images/home/play.png" alt="" />
      {{ $t("home.v2.film.btn") }}
    </p>
    <!-- 视频弹窗：fade 过渡 + 点击遮罩区域关闭 -->
    <transition name="video-fade">
      <div class="video-modal" v-if="dialogVisible" @click="closeVideo">
        <div class="video-dialog" @click.stop>
          <video
            ref="filmVideo"
            class="film-video"
            controls
            loop
            playsinline
            webkit-playsinline
          ></video>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Hls from "hls.js";

export default {
  name: "FilmSection",
  data() {
    return {
      dialogVisible: false,
    };
  },
  mounted() {},

  beforeDestroy() {
    if (this.hls) {
      this.hls.destroy();
      this.hls = null;
    }
  },
  methods: {
    // 供 HeroSection 按钮调用：仅滚动到视频区域，不自动弹窗
    playVideo() {
      this.$el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    // 点击播放按钮：打开弹窗并播放
    openVideoDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.initVideo();
        const video = this.$refs.filmVideo;
        if (video && video.paused) {
          video.play().catch(() => {});
        }
      });
    },
    // 点击遮罩关闭弹窗，暂停播放并销毁 hls
    closeVideo() {
      this.dialogVisible = false;
      const video = this.$refs.filmVideo;
      if (video) {
        video.pause();
      }
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
      }
    },
    initVideo() {
      const video = this.$refs.filmVideo;
      if (!video) return;
      // 本地 hls 文件流地址（m3u8 及 ts 分片文件放在 public/video/ 目录下）
      // 中文环境播放中文版，其他语言播放英文版
      const videoName = (this.$i18n.locale || "").indexOf("zh") === 0
        ? "film-cn"
        : "film-en";
      const src = process.env.BASE_URL + "video/" + videoName + ".m3u8";
      if (Hls.isSupported()) {
        // Chrome / Edge / Firefox / 安卓 WebView：通过 MSE 加载 HLS
        this.hls = new Hls();
        this.hls.loadSource(src);
        this.hls.attachMedia(video);
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        // Safari / iOS：原生支持 HLS，直接设置 src
        video.src = src;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.film-section {
  width: 100%;
  height: 1081px;
  display: flex;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
  background-size: 100% 100%;
  background-image: url("../../../assets/img/images/home/film-bj.png");
  .p1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    margin-bottom: 8px;
  }
  .p2 {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: clamp(32px, 2.75vw, 60px);
    color: #ffffff;
    line-height: 60px;
  }
  .p3 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #ffffff;
    margin-top: 16px;
  }
  .p4 {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 24px;
    color: #ffffff;
    margin-top: 60px;
    img {
      width: 32px;
      height: 32px;
      margin-right: 20px;
    }
  }
  // 视频弹窗：全屏遮罩 + 70% 宽度弹窗，左右上下居中
  .video-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    .video-dialog {
      width: 70%;
      height: 80%;
      position: relative;
      border-radius: 12px;
      overflow: hidden;
      background: #000000;
      .film-video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
  }
}
// fade 过渡动画
.video-fade-enter-active,
.video-fade-leave-active {
  transition: opacity 0.3s ease;
  .video-dialog {
    transition: transform 0.3s ease;
  }
}
.video-fade-enter,
.video-fade-leave-to {
  opacity: 0;
  .video-dialog {
    transform: scale(0.95);
  }
}
</style>
